export default __webpack_public_path__ + "static/media/gq.eed957fc.svg";